/**
 * 车队风险评估报告的相关请求
 */
import request from "@/utils/request";

// 获取车队风险月报数据
export const fleetRiskMonthReportRequest = (data: any) => {
  return request.post('/api/v2/projectReport/month/info', data)
}

// 导出车队风险报告
export const fleetRiskMonthReportExportRequestPath = '/api/v2/projectReport/month/export';

// 获取车队风险报告数据
export const fleetRiskReportRequest = (data: any) => {
  return request.post(
    '/api/v2/safeReport/v1/detail',
    // '/api/v2/safeReport/detail',
    data,
    // {
    //   headers: {
    //     'x-admin-id': '1',
    //     'x-cate-id': '1674',
    //   }
    // }
  )
}

// 根据车队获取车队车辆（可按服务商 insuranceId 过滤）
export const motorcadeCarList = (params?: { cateName?: string; insuranceId?: number }) => {
  return request.get('/api/v2/car/carList', { params })
}

//根据分组获取车队车辆
export const getAllCarsByCateIds = (cateId: string[]) => {
  const paramsStr = cateId.map(id => `cateId=${id}`).join('&');
  return request.get(`/api/v2/car/list/cate?${paramsStr}`, {
    // headers: {
    //   'x-admin-id': '1',
    //   'x-cate-id': '1674',
    // }
  })
}

// 导出车队风险报告
export const fleetRiskReportExportRequestPath = '/api/v2/safeReport/v1/export';

interface FleetRiskPushRecordRequestParams {
  page: number,
  limit: number,
  beginDate: string;
  endDate: string;
}
// 获取风险报告的推送记录
export const fleetRiskPushRecordRequest = (params: FleetRiskPushRecordRequestParams) => {
  return request.get('/api/v2/safeReport/record', {
    params
  })
}

// 获取风险报告的推送配置
export const fleetRiskPushConfigRequest = () => {
  return request.get('/api/v2/safeReport/config')
}

// 设置风险报告的推送配置
export const fleetRiskPushConfigSettingRequest = (data: any) => {
  return request.post('/api/v2/safeReport/config', data)
}


//获取管辖范围内内的车队 
export const cateAllCompanyRequest = () => {
  return request.get('/api/v2/cate/allCompany')
}


//获取当前用户权限下的所有车队
export const getAllCompanyByUserRequest = () => {
  return request.get('/api/v2/company/listV2')
}


// 服务商（保司）选项 - 对应后端 com.anchezhixing.commonMapper.insurance.entity.Insurance
export interface InsuranceOption {
  id: number;
  name: string;
  state: string;
  projectId: number;
}

// /api/v2/insurer/options 响应
// 细化自通用 R 响应（com.anchezhixing.common.dto.R），data 为保司列表
export interface InsurerOptionsResponse {
  code?: number | null;
  count?: number | null;
  data?: InsuranceOption[];
  ignoreColumns?: string[] | null;
  msg?: null | string;
  success?: boolean | null;
  [property: string]: any;
}

// 获取服务商（保司）全量选项
export const getInsurerOptionsRequest = () => {
  return request.get<InsurerOptionsResponse>('/api/v2/insurer/options')
}


export type iFleetReportV2Params = {
  "start_date": string,
  "end_date": string,
  "fleet_names": string[],
  "plate_numbers": string[],
  // 服务商名称（来自服务商选项选中项的 name），非必填
  "insurance_company"?: string,
}
// 车队报告V2查询接口
export const getFleetReportV2Request = (data: iFleetReportV2Params) => {
  return request.post('/api/v2/company/week/report/detail', data,

    {
      headers: {
        'x-admin-id': '1',
        'x-cate-id': '1674',
      }
    }
  )
}
export type iExportFleetReportV2Response = {
  report_name: string,
} & iFleetReportV2Params
// 车队报告V2导出接口
export const exportFleetReportV2Request = (data: iExportFleetReportV2Response) => {
  return request.post('/api/v2/company/week/report/detail/create', data,
    {
      headers: {
        'x-admin-id': '1',
        'x-cate-id': '1674',
      }
    }
  )
}